import { Card, CloseIcon, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';

function PreviewError() {
  return (
    <Card className="items-center flex-row justify-around p-4 mt-10 gap-x-2">
      <CloseIcon color="red" />
      <Typography>
        <T kind="Something went wrong" />
      </Typography>
    </Card>
  );
}

export default observer(PreviewError);
